import { Component } from "react";
import { NavLink as Link } from "react-router-dom";

import { logout, upperCaseOfName, callBackendAPI, setOrGetCookiesValue, generateSource, cancelToken } from './../helpers/common';
import { translate } from './../helpers/intl_helpers';
import { UserDetails } from '../UserDetails';
import { STATUS_SUCCESS, NO_ACCESS_PERMISSION } from './../config/global_constants';

import hamburgerMenuIcon from '../assets/images/hamburgermenu.svg';
import copyIcon from '../assets/images/copy_icon.svg';
import tickIcon from '../assets/images/green_tick_icon.svg';
import resetIcon from '../assets/images/reset.svg';


class Header extends Component {
	source;

	static contextType = UserDetails;
	constructor(props) {
		super(props);

		let tmpDarkVal = setOrGetCookiesValue('searchStatsDarkMode');

		this.state = {
			userDetail: {},
			imageUrl: "",
			noImageUrl: "",
			isDarkMode: (tmpDarkVal && tmpDarkVal.isDarkMode === true) ? true : false,
			showPasswordModal: false,
			generatedPassword: "",
			copied: false
		};

		this.Logout = this.Logout.bind(this);
		this.toggleDarkMode = this.toggleDarkMode.bind(this);
		this.generatePassword = this.generatePassword.bind(this);
		window.scrollTo(0, 0);
	}

	/**
	* For get user details
	*/
	componentDidMount() {
		/** Generate source for cancel token */
		this.source = generateSource();

		let savedDarkMode = setOrGetCookiesValue('searchStatsDarkMode');
		let mockEvent = {
			target: {
				checked: (savedDarkMode && savedDarkMode.isDarkMode === true) ? true : false
			}
		};
		// Call the toggleDarkMode function with the mock event
		this.toggleDarkMode(mockEvent);

		callBackendAPI([{ model: 'my_account', method: 'getUserDetails' }], this.source).then(response => {
			if (response.success && response.data[0].status === STATUS_SUCCESS && response.data[0].result) {
				this.setState({
					userDetail: response.data[0].result,
					imageUrl: response.data[0].file_url,
					noImageUrl: response.data[0].no_img_url
				});
			}
		}).catch(err => console.log(err));
	}

	componentWillUnmount() {
		cancelToken(this.source); // cancel the request
	}

	generatePassword(regenerate = false) {
		callBackendAPI([
			{
				model: "home",
				method: "generatePassword",
				regenerate
			}
		], this.source)
		.then((response) => {
			if (response.success && response.data[0].status === STATUS_SUCCESS) {
				this.setState({
					showPasswordModal: true,
					generatedPassword: response.data[0].password || "",
					copied: false
				});
			}
		})
		.catch((err) => console.log(err));
	}

	copyPassword = async () => {
		const text = this.state.generatedPassword;

		try {
			if (navigator.clipboard && navigator.clipboard.writeText) {
				await navigator.clipboard.writeText(text);
			} else {
				const textArea = document.createElement("textarea");
				textArea.value = text;

				document.body.appendChild(textArea);
				textArea.select();
				document.execCommand("copy");
				document.body.removeChild(textArea);
			}

			this.setState({ copied: true });

			setTimeout(() => {
				this.setState({ copied: false });
			}, 2000);
		} catch (err) {
			console.error("Copy failed:", err);
		}
	};

	/**
	* For user logout
	*
	* @param null
	*
	* @return void
	*/
	Logout() {
		logout()
	}// end Logout()

	/**
	* Toggle dark mode based on checkbox
	*/
	toggleDarkMode(event) {
		const isChecked = event.target.checked;

		setOrGetCookiesValue('searchStatsDarkMode', true, { isDarkMode: isChecked });
		this.setState({ isDarkMode: isChecked });

		// Add or remove 'dark-mode' class based on checkbox state
		if (isChecked) {
			document.body.classList.add('dark-mode');
		} else {
			document.body.classList.remove('dark-mode');
		}
	}

	render() {
		const { userDetail, imageUrl, noImageUrl } = this.state;
		return (
			<div className="top-header defaultMenu-open">
				<button type="button" className="menu-btn" aria-labelledby="menu-button">
					<img src={hamburgerMenuIcon} alt="Menu Button" id="menu-button" width={25} height={18} />
				</button>
				<div className="top-header-right">
					<div className="header-profile">
						<div className="header-profile-inner d-flex align-items-center">
							<div className="dropdown">
								<div className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
									<span className={`${(userDetail && !userDetail.image) ? 'greenbg' : ''}`}>
										{userDetail && userDetail.image && imageUrl ? (
											<figure className="mb-0">
												<img src={`${imageUrl}${userDetail.image}`} alt="User profile" onError={(event) => event.target.src = noImageUrl} />
											</figure>
										) : (
											upperCaseOfName(userDetail.first_name ? userDetail.first_name : "", userDetail.last_name ? userDetail.last_name : "")
										)}
									</span>
									<div className="profile-info">
										<strong className="profile-name d-block">{(userDetail && userDetail.full_name) ? userDetail.full_name : ""}</strong>
									</div>
								</div>
								<ul className="dropdown-menu">
									<li><Link className="dropdown-item" to="/edit-profile">{translate("header.update_profile")} </Link></li>
									{userDetail.login_token && userDetail.subcontractor_permission_level && userDetail.subcontractor_permission_level !== NO_ACCESS_PERMISSION && (
										<li>
											<a
												className="dropdown-item"
												href={`${process.env.REACT_APP_SUBCONTRACTOR_URL}system-login?auth=${userDetail.login_token}`}
												target="_blank"
												rel="noopener noreferrer"
											>
												{translate("header.subcontractor")}
											</a>
										</li>
									)}
									<li className='d-flex align-items-center justify-content-between'>
										<span>{translate("header.dark_mode")}</span>
										<div className="visibility-mode">
											<input
												type="checkbox"
												id="switch"
												checked={this.state.isDarkMode}
												onChange={this.toggleDarkMode}
											/>
											<label htmlFor="switch">{translate("header.toggle")}</label>
										</div>
									</li>
									<li> 
										<button
											type="button"
											className="dropdown-item border-0 bg-transparent text-start w-100"
											onClick={() => this.generatePassword(false)}
										>
											{translate("header.generate_passoword")}
										</button>
									</li>
									<li><Link className="dropdown-item" to="#" onClick={() => this.Logout()}>{translate("header.logout")}</Link></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				{this.state.showPasswordModal && (
					<div className="modal fade show d-block">
						<div className="modal-dialog">
							<div className="modal-content">
								<div className="modal-header">
									<h5 className="modal-title">
										{translate("header.password")}
									</h5>
									<button
										type="button"
										className="btn-close"
										onClick={() =>
											this.setState({
												showPasswordModal: false
											})
										}
									/>
								</div>

								<div className="position-relative">
									<input
										type="text"
										className="form-control pe-5"
										readOnly
										value={this.state.generatedPassword}
									/>

									<div
										style={{
											position: "absolute",
											right: "10px",
											top: "50%",
											transform: "translateY(-50%)",
											display: "flex",
											alignItems: "center",
											gap: "8px"
										}}
									>
										<img
											src={resetIcon}
											alt="Refresh"
											width={18}
											height={18}
											onClick={() => this.generatePassword(true)}
											style={{ cursor: "pointer" }}
										/>

										<img
											src={this.state.copied ? tickIcon : copyIcon}
											alt="Copy"
											width={18}
											height={18}
											onClick={this.copyPassword}
											style={{ cursor: "pointer" }}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		);
	}
}
export default Header;
